import { Row, Col, ClassifyStructure, Form, message, Card, Transfer, Select, Modal, Input, jsonToQueryString, Button, MainModal, Typography, Tabs } from './../ui/ot';
import axios from 'axios';
// import ClassifyStructure from '../classify/Main';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs'
import InformationModal from '../classify/components/InformationModal';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDepartmentRole } from './controllers/department_role_controller';
import { useRole } from './controllers/role_controller';
import { createContext } from 'react';
import { PermissionListModal, PermissionListForm } from '../permission_management/PermissionList';
import PermissionModal from "../permission_management/PermissionModal";
import { useStaffDiverge } from '../permission_management/controllers/staff_diverge_controller'
import { useCRUDController } from '../ui/classify_structure/CRUDController';
const LanguageContext = createContext(null)

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => (value === "" || !value) ? { ...all } : { ...all, [key]: value }, {})
}
const DepartmentRoleManagement = ({
    keyPrefix = "organization_structure.role",
    mode = 'departmentRole',
    permission_modal_mode = 'group'
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const [searchParams] = useSearchParams()
    const departmentIdExternal = searchParams?.get('department_id')
    const navigate = useNavigate()
    const [departmentData, setDepartmentData] = useState([]);
    const [departmentOption, setDepartmentOption] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [departmentProcessData, setDepartmentProcessData] = useState([]);
    const [roleProcessData, setRoleProcessData] = useState([]);
    const [departmentId, setDepartmentId] = useState(null);
    const [roleId, setRoleId] = useState(null);
    const [departmentName, setDepartmentName] = useState([]);
    const [roleName, setRoleName] = useState([]);
    const [targetKeys, setTargetKeys] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState({
        edit: true,
        prefix: "department",
        languageKey: "department_language_data",
        node: [],
        data: { name: "" }
    });
    const current_department_id = useRef()
    const selectRef = useRef()
    const [forceReload, setForceReload] = useState(0)
    const extraParamsRef = useRef({})
    const [title, setTitle] = useState();
    const [color, setColor] = useState('d65b77');

    /* PermissionModal */
    const [open, setOpen] = useState(false);
    const [edit, setEdit] = useState(false);
    const [editcard, setEditCard] = useState({});
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, set_loading] = useState(0)
    const [search_date, set_search_date] = useState([])
    const [total, set_total] = useState(1);
    const [datas, setDatas] = useState([])
    const actionRef = useRef();
    /* PermissionModal */

    const [form] = Form.useForm();
    /* PermissionModal */
    const handleEdit = () => {
        if (editcard['user_permission_data'].length === 0) {
            messageApi.open({
                type: 'warning',
                content: '請勾選人員權限管理',
            });
        } else {
            axios
                .patch(`/organization_structure/api/staff_diverge`, [
                    {
                        ...editcard,
                        user_permission_data: editcard.user_permission_data.map(map_item => (
                            {
                                ...map_item,
                                permission_time_start: editcard.permission_time_start,
                                permission_time_end: editcard.permission_time_end
                            }
                        ))
                    }
                ])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '修改失敗',
                        });
                        actionRef.current.reload()
                        // reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '修改成功',
                        });
                        actionRef.current.reload()
                        // reload();
                    }
                })
        }
    }
    const handleSubmit = () => {
        axios
            .post(`/cramSchool/api/permission/manage`, [{ ...editcard }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '新增失敗',
                    });
                    getData();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    getData();
                }
            })
    }
    const cancel = () => {
        setOpen(false)
    }
    const getData = (param, sort, filter, checklist) => {
        set_loading(true);
        let params = {};
        params = {
            cur_page: param?.current,
            size: param?.pageSize,
            custom_filter_key: checklist,
            custom_filter_value: param?.keyword,
            permission_time_start: search_date[0],
            permission_time_end: search_date[1],
            order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
        }
        params = setParamsFilter(params)
        return axios
            .get('/organization_structure/api/staff_diverge', {
                params: params,

            })
            .then((response) => {
                set_total(response.data.total || 0)
                setDatas(response.data.data || []);
                if (response.data.data) {
                    get_picture(response.data.data);
                }
            })
            .finally(() => {
                set_loading(false)
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let serial_name = value['serial_name']
            // console.log(student_id);
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            // console.log(dataurl)
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (serial_name == value.serial_name) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )
                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    const onFormFinish = ({

    }) => {
        const values = form.getFieldsValue()
        patchStaffDivergeData([{
            user_id: values?.user_id,
            user_permission_data: Object.entries(values?.user_permission_data)?.map(([key, value]) => {
                return {
                    user_id: values?.user_id,
                    permission_id: key,
                    permission_level_id: value,
                    permission_time_start: dayjs(values?.permission_time_start).format('YYYY-MM-DD'),
                    permission_time_end: dayjs(values?.permission_time_end).format('YYYY-MM-DD')
                }
            }).filter(item => item?.permission_level_id)
        }])
    }
    const {
        patchStaffDivergeData
    } = useStaffDiverge({
        onFinish: ({ axiosMode, status, values }) => {
            if (axiosMode === 'patch') {
                if (status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    actionRef.current.reload()
                    // reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    actionRef.current.reload()
                    // reload();
                }
            }
        }
    })
    const editRow = (record) => {
        let first = record?.user_permission_data?.find((ele) => true)

        setTitle('修改');
        setColor('f09a45');
        setEdit(true);
        setOpen(true);

        setEditCard({
            ...record,
            permission_time_start: first?.permission_time_start,
            permission_time_end: first?.permission_time_end
        })
    }
    /* PermissionModal */


    const onReset = () => {
        form.resetFields();
    };
    const cancelModal = () => {
        setModalData({
            edit: true,
            languageKey: "department_language_data",
            node: [],
            data: { name: "" }
        })
    }
    const addModal = (prefix, languageKey, node) => {

        setModalData((prev) => {
            return {
                edit: false,
                prefix: prefix,
                languageKey: languageKey,
                node: node,
                data: { name: "" }
            }
        })
        setModalShow(true)
    }

    const createNodeDepartment = (values, selectedNode) => {

        let url = `/organization_structure/api/department`;
        let classify_structure_type_id = 0;
        let hasParent = 0;

        if (selectedNode?.classify_structure_type_id) {
            classify_structure_type_id = selectedNode?.classify_structure_type_id
            hasParent = 1;
        } //有沒有selected

        let data = {
            "classify_structure_id": 9,
            "classify_structure_type_id": classify_structure_type_id,
            "name": values?.name,
            "department_language_data": [
                {
                    "language_culture_code": "zh-tw",
                    "language_culture_value": values?.name
                }
            ]
        }
        createNode("department", values, selectedNode, url, data, hasParent)
    }
    const createNodeRole = (values, selectedNode) => {
        let url = `/organization_structure/api/role`;
        let classify_structure_type_id = 0;
        let hasParent = 0;

        if (selectedNode?.classify_structure_type_id) {
            classify_structure_type_id = selectedNode?.classify_structure_type_id
            hasParent = 1;

        } //有沒有selected

        let data = {
            "classify_structure_id": 8,
            "department_id": departmentId,
            "department_role_index": 1,
            "classify_structure_type_id": classify_structure_type_id,
            "name": values?.name,
            "role_language_data": [
                {
                    "language_culture_code": "zh-tw",
                    "language_culture_value": values?.name
                }
            ]
        }
        createNode("role", values, selectedNode, url, data, hasParent)
    }
    const createNode = (type, values, selectedNode, url, data, hasParent) => {
        if (hasParent) { //有沒有selected
            axios.post(url, data)
                .then(response => {
                    if (response?.data?.status === "success") {
                        message.success('新增成功');
                        if (type === "department") {
                            setDepartmentProcessData([1, "create", selectedNode?.classify_structure_type_id, values?.name, 9, response.data["classify_structure_type_id"], response.data["classify_structure_type_id"], [], response.data])
                        }
                        else {
                            setRoleProcessData([1, "create", selectedNode?.classify_structure_type_id, values?.name, 8, response.data["classify_structure_type_id"], response.data["classify_structure_type_id"], [], response.data])
                        }
                    }
                    else {
                        message.error('新增失敗');
                    }
                })
                .catch((error) => {
                })
                .finally(() => {
                    setModalData({
                        edit: true,
                        prefix: "department",
                        languageKey: "department_language_data",
                        node: [],
                        data: { name: "" }
                    })
                })
        } else {
            axios.post(url, data)
                .then(response => {
                    if (response.data.status === "success") {
                        message.success('新增成功');
                        if (type === "department") {
                            setDepartmentProcessData([2, values.name, response.data["classify_structure_type_id"], response.data["classify_structure_type_id"], 0, [Date.now()], [], response.data])
                        }
                        else {
                            setRoleProcessData([2, values.name, response.data["classify_structure_type_id"], response.data["classify_structure_type_id"], 0, [Date.now()], [], response.data])
                        }
                    }
                    else {
                        message.error('新增失敗');
                    }
                })
                .catch((error) => {
                })
                .finally(() => {
                    setModalData({
                        edit: true,
                        prefix: "department",
                        languageKey: "department_language_data",
                        node: [],
                        data: { name: "" }
                    })
                })
        };
    }
    const editModal = (prefix, languageKey, node) => {
        let data = {
            "name": node[`${languageKey}`]?.[0]?.language_culture_value !== undefined
                ? node[`${languageKey}`]?.[0]?.language_culture_value
                : node.name

        }
        setModalData({
            edit: true,
            prefix: prefix,
            languageKey: languageKey,
            node: node,
            data: data
        })
        setModalShow(true)
    }

    //編輯節點名稱
    const editNodeDepartment = (node, newName) => {
        let url = `/organization_structure/api/department`;
        let data = [{
            "department_id": node?.department_id,
            "classify_structure_id": 9,
            "classify_structure_type_id": node?.classify_structure_type_id,
            "name": newName,
            "department_language_data": [
                {
                    "language_manage_id": node?.department_language_data[0]?.language_manage_id,
                    "language_culture_code": "zh-tw",
                    "language_culture_value": newName
                }
            ]
        }]
        editNode("department", url, data, node.classify_structure_type_id, newName)
    }
    const editNodeRole = (node, newName) => {
        let url = `/organization_structure/api/role`;
        let data = [{
            "role_id": node.role_id,
            "classify_structure_id": 8,
            "classify_structure_type_id": node.classify_structure_type_id,
            "name": newName,
            "role_language_data": [
                {
                    "language_manage_id": node?.role_language_data[0]?.language_manage_id,
                    "language_culture_code": "zh-tw",
                    "language_culture_value": newName
                }
            ]
        }]
        editNode("role", url, data, node.classify_structure_type_id, newName)
    }
    const editNode = (type, url, data, classify_structure_type_id, newName) => {
        axios.patch(url, data)
            .then(response => {
                if (response.data.status === "success") {
                    if (type === "department") {
                        setDepartmentProcessData([3, "edit", classify_structure_type_id, newName])
                        setDepartmentName(newName)
                    }
                    else {
                        setRoleProcessData([3, "edit", classify_structure_type_id, newName])
                        setRoleName(newName)
                    }
                    message.success('修改成功');
                }
                else {
                    message.error('修改失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setModalData({
                    edit: true,
                    prefix: "role",
                    languageKey: "role_language_data",
                    node: [],
                    data: { name: "" }
                })
            })
    };
    const deleteDepartment = (node, classify_structure_type_id) => {
        let url = `/organization_structure/api/department`;
        let data = [{
            "department_id": node.department_id,
            "classify_structure_id": 9,
            "classify_structure_type_id": classify_structure_type_id,
        }]
        deleteNode("department", url, data, classify_structure_type_id)

    }
    const deleteRole = (node, classify_structure_type_id) => {
        let url = `/organization_structure/api/role`;
        let data = [{
            "role_id": node.role_id,
            "classify_structure_id": 8,
            "classify_structure_type_id": classify_structure_type_id,
        }]
        deleteNode("role", url, data, classify_structure_type_id)
    }
    //刪除訊息、找刪除節點
    const deleteNode = (type, url, data, classify_structure_type_id) => {
        axios
            .delete(url, { data: data })
            .then(response => {
                if (response.data.status === "success") {
                    message.success('刪除成功');
                    if (type === "department") {
                        setDepartmentProcessData([4, "delete", classify_structure_type_id])
                        if (data?.[0]?.department_id === departmentId) {
                            setDepartmentId(null)
                        }
                    }
                    else {
                        setRoleProcessData([4, "delete", classify_structure_type_id])
                        if (data?.[0]?.role_id === roleId) {
                            setRoleId(null)
                        }
                    }
                }
                else {
                    message.error('刪除失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {

            })
    };
    const getDepartmentId = (node) => {
        if (node) {
            setDepartmentId(node?.department_id)
            let name = node?.department_language_data[0].language_culture_value
            setDepartmentName(name !== undefined ? name : node?.name)
        }
        else {
            setDepartmentId(null)
        }
    }
    const getRoleId = (node) => {
        if (node) {
            setRoleId(node?.role_id)
            let name = node?.role_language_data[0].language_culture_value
            setRoleName(name !== undefined ? name : node?.name)
        }
        else {
            setRoleId(null)
        }
    }
    const onChange = (newTargetKeys, direction, moveKeys) => {
        setTargetKeys(newTargetKeys);
    };
    const postUserRole = (departmentId, roleId, userIdArray) => {
        let data = [{
            "department_id": departmentId,
            "role_id": roleId,
            "user_id": userIdArray,
        }]
        console.log(data)
        axios.post('/organization_structure/api/user_role', data)
            .then(response => {
                if (response.data.status === "success") {
                    message.success('儲存成功');
                }
                else {
                    message.error('儲存失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setRoleId(undefined)
            })
    };
    const isInteger = (value) => {
        // Convert the value to an integer using parseInt
        let parsedValue = parseInt(value, 10);
        // Check if the parsed value is NaN or not equal to the original value (converted to a string)
        return !isNaN(parsedValue) && parsedValue.toString() === value.toString();
    }
    useEffect(() => {
        if (userData) {
            axios.get('/organization_structure/api/user_role', {
                params: {
                    department_id: departmentId,
                    role_id: roleId
                }
            })
                .then(response => {
                    let newTargetKeys = []
                    newTargetKeys = response.data['data'].map((map_item, index) => (
                        map_item.user_id.toString()
                    ))
                    setTargetKeys(newTargetKeys)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [userData])

    useEffect(() => {
        setUserData([])
        if (roleId) {
            axios.get('/organization_structure/api/user')
                .then(response => {
                    let newUserData = []
                    newUserData = response.data?.data?.map((map_item, index) => {
                        return {
                            key: String(map_item.user_id),
                            title: `${map_item.staff_name}-${map_item.serial_name}`
                        }
                    })
                    setUserData(newUserData)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [roleId])

    // useEffect(() => {
    //     setRoleId()
    //     setRoleData([])
    //     if (departmentId) {
    //         axios.get('/organization_structure/api/role', {
    //             params: {
    //                 classify_structure_id: 8,
    //                 department_id: departmentId,
    //                 classify_structure_type_id: 0
    //             }
    //         })
    //             .then(response => {
    //                 setRoleData(response.data['data'])
    //             })
    //             .catch((error) => {
    //             })
    //             .finally(() => {
    //             })
    //     }
    // }, [departmentId])
    const init = async () => {
        let firstDepartment
        await axios.get('/organization_structure/api/department', {
            params: {
            }
        })
            .then(response => {
                setDepartmentOption(response.data['data'])
                firstDepartment = response.data['data']?.find(_ => true)?.department_id
            })
            .catch((error) => {
            })
            .finally(() => {
            })
        if (departmentIdExternal) {
            current_department_id.current = departmentIdExternal
            setDepartmentId(isInteger(departmentIdExternal) ? parseInt(departmentIdExternal) : departmentIdExternal)
        } else if (firstDepartment) {
            current_department_id.current = firstDepartment
            setDepartmentId(isInteger(firstDepartment) ? parseInt(firstDepartment) : firstDepartment)
        }
    }
    useEffect(() => {
        // axios.get('/organization_structure/api/department', {
        //     params: {
        //         classify_structure_id: 9,
        //         classify_structure_type_id: 0
        //     }
        // })
        //     .then(response => {
        //         setDepartmentData(response.data['data'])
        //     })
        //     .catch((error) => {
        //     })
        //     .finally(() => {
        //     })
        init()
    }, [])

    useEffect(() => {
    }, [targetKeys])
    useEffect(() => {
        setForceReload(pre => pre + 1)
    }, [current_department_id.current])

    return (<>
        <LanguageContext.Provider value={keyPrefix}>
            {permission_modal_mode === "all" && <>
                <PermissionModal
                    open={open}
                    edit={edit}
                    title={title}
                    color={color}
                    editcard={editcard}
                    setEditCard={setEditCard}
                    setOpen={setOpen}
                    handleEdit={handleEdit}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                />
            </>}
            {permission_modal_mode === "group" && <>
                <PermissionListModal
                    axiosMode="post"
                    propsForm={form}
                    propsOpen={open}
                    propsLoading={loading}
                    propsSetOpen={setOpen}
                    onFinish={onFormFinish}
                    editcard={editcard}
                />
            </>}
            {modalData.prefix === "department"
                ?
                <InformationModal
                    title={"單位資訊"}
                    edit={modalData.edit}
                    value={modalData?.data}
                    treeNode={modalData?.node}
                    modalShow={modalShow}
                    onSubmit={createNodeDepartment}
                    onChange={editNodeDepartment}
                    setModalShow={setModalShow}
                    cancelModal={cancelModal}
                ></InformationModal>
                :
                <InformationModal
                    title={"職稱資訊"}
                    edit={modalData.edit}
                    value={modalData.data}
                    treeNode={modalData.node}
                    modalShow={modalShow}
                    onSubmit={createNodeRole}
                    onChange={editNodeRole}
                    setModalShow={setModalShow}
                    cancelModal={cancelModal}
                ></InformationModal>
            }
            <Row gutter={[8, 8]} align={'top'}>
                {(mode === "departmentRole" || mode === 'department') && <>
                    <Col span={24}>
                        <Typography.Title level={3}>
                            部門(單位)設定
                        </Typography.Title>
                    </Col>
                    <Col span={mode === "department" ? 24 : 12}>
                        {/* <Card
                            title="單位設定"
                        > */}
                        <ClassifyStructure
                            selectRef={selectRef}
                            propsForm={form}
                            prefixTitle="department"
                            apiRoute='/organization_structure/api/department'
                            customColumns={[
                                {
                                    title: '名稱',
                                    dataIndex: 'name',
                                    key: 'name',
                                    render: (text, record, index) => (
                                        record[`department_language_data`]?.[0]?.language_culture_value !== undefined
                                            ? record[`department_language_data`]?.[0].language_culture_value
                                            : record.name
                                    )
                                },
                                {
                                    title: '層級名稱',
                                    dataIndex: 'depth_name',
                                    key: 'depth_name'
                                },
                                {
                                    title: '額外資訊',
                                    dataIndex: 'property_json',
                                    key: 'property_json',
                                    render: (text) => <>
                                        <Row>
                                            {Object.keys(text).map(item => <Col span={24}>{item}：{text[item]}</Col>)}
                                        </Row>
                                    </>
                                },
                                {
                                    title: '職位數',
                                    dataIndex: 'count_role',
                                    key: 'count_role'
                                },
                                {
                                    title: '人員數',
                                    dataIndex: 'count_user',
                                    key: 'count_user'
                                },
                            ]}
                            extraActionRender={(record) => <>
                                <Button type="primary"
                                    size={"small"}
                                    style={{ verticalAlign: 'middle', backgroundColor: "#E6E2C3", color: "black" }}
                                    onClick={(e) => {
                                        navigate('./../role?' + jsonToQueryString({ department_id: record?.department_id }))
                                    }}
                                >職位</Button>
                                <Button type="primary"
                                    size={"small"}
                                    style={{ verticalAlign: 'middle', backgroundColor: "#FFCC00", color: "black" }}
                                    onClick={(e) => {
                                        editRow(record)
                                    }}
                                >權限</Button>
                                {record?.classify_structure_type_parent_id === 0 && <>
                                    <PatchDepth
                                        record={record}
                                        prefix='department'
                                        keyPrefix='organization_structure.department.depth'
                                        apiRoute='/organization_structure/api/department_depth'
                                        onReload={() => selectRef.current.reload()}
                                    />
                                </>}
                            </>}
                            customFormItems={() => {
                                return <>
                                    <Form.Item
                                        name={"department_id"}
                                        hidden
                                    ></Form.Item>
                                    <Form.Item
                                        name={"classify_structure_type_id"}
                                        hidden
                                    ></Form.Item>
                                    <Form.Item
                                        name={"department_language_data.0.language_manage_id"}
                                        hidden
                                    ></Form.Item>
                                    <Form.Item
                                        name={"department_language_data.0.language_culture_code"}
                                        hidden
                                    >
                                    </Form.Item>
                                    <Form.Item
                                        name={"department_language_data.0.language_culture_value"}
                                        hidden
                                    >
                                    </Form.Item>
                                    <Form.Item
                                        name={"property_json"}
                                    >
                                        <PropertyJson />
                                    </Form.Item>
                                </>
                            }}
                            classify_structure_id={9}
                            classify_structure_type_id={0}
                            initialValues={{
                                "department_language_data": [
                                    {
                                        "language_manage_id": undefined,
                                        "language_culture_code": "zh-tw",
                                        "language_culture_value": ""
                                    }
                                ]
                                // permission_id: null,
                                // path_check: 0,
                                // path_check_replace: false,
                                // show_replace: false,
                                // show: 0,
                                // menu_permission_data: [{
                                //     // menu_id: current_department_id?.current
                                // }],
                                // property_json: {
                                //     blod: false,
                                //     italic: false,
                                //     textDecoration: false,
                                //     background_color1: null,
                                //     background_color2: null
                                // }

                            }}
                            reorganizeFormData={(value, type) => {
                                if (type === "submit") {
                                    let newData = [{
                                        "department_id": value?.department_id,
                                        "classify_structure_id": 9,
                                        "classify_structure_type_id": value?.classify_structure_type_id,
                                        "name": value?.name,
                                        "department_language_data": [
                                            {
                                                "language_manage_id": value?.department_language_data?.[0]?.language_manage_id,
                                                "language_culture_code": "zh-tw",
                                                "language_culture_value": value?.name
                                            }
                                        ],
                                        "property_json": value?.property_json
                                    }]
                                    let firstData = newData.find((ele) => true)
                                    return {
                                        ...firstData
                                    };
                                } else if (type === "set") {
                                    let newData = [{
                                        "department_id": value?.department_id,
                                        "department_department_index": 1,
                                        "classify_structure_id": 9,
                                        "classify_structure_type_id": value?.classify_structure_type_parent_id,
                                        "name": value?.name,
                                        "department_language_data": [
                                            {
                                                "language_manage_id": value?.department_language_data?.[0]?.language_manage_id,
                                                "language_culture_code": "zh-tw",
                                                "language_culture_value": value?.name
                                            }
                                        ],
                                        "property_json": value?.property_json
                                    }]
                                    let firstData = newData.find((ele) => true)
                                    return {
                                        ...firstData
                                    };
                                }
                            }}
                            extraParams={{
                                // menu_id: current_department_id.current
                            }}
                            // forceReload={forceReload}


                            chartShow={true}
                            treeData={departmentData}
                            onSubmit={addModal}
                            onChange={editModal}
                            processData={departmentProcessData}
                            deleteNode={deleteDepartment}
                            onSelect={getDepartmentId}
                            chartTitle={'單位組織架構圖'}
                            treeTitle={''}
                            extra_column={[
                                {
                                    title: '職位數',
                                    dataIndex: 'count_role',
                                    key: 'count_role'
                                },
                                {
                                    title: '人員數',
                                    dataIndex: 'count_user',
                                    key: 'count_user'
                                },
                            ]}
                            link={(record) => {
                                navigate('./../role?' + jsonToQueryString({ department_id: record?.department_id }))
                            }} />
                        {/* </Card> */}
                    </Col>
                </>}
                {(mode === "departmentRole" || mode === 'role') && <>
                    <Col span={24}>
                        <Typography.Title level={3}>
                            職稱(角色身份)設定
                        </Typography.Title>
                    </Col>
                    <Col span={mode === "role" ? 24 : 12}>

                        <Row gutter={[8, 8]} align={'top'}>
                            {false && <>
                                <Col>
                                    目前編輯所屬單位：
                                </Col>
                                <Col>
                                    <Select
                                        options={departmentOption.map(item => {
                                            return {
                                                label: item?.department_language_data?.find(item => item.language_culture_code === "zh-tw")?.language_culture_value || item.title,
                                                value: item.department_id
                                            }
                                        })}
                                        value={departmentId}
                                        onChange={(e) => {
                                            setDepartmentId(e)
                                            current_department_id.current = e
                                        }}
                                        defaulDisabled={true}
                                    />
                                </Col>
                            </>}
                            <Col span={24}>
                                {/* {departmentId && (<> */}
                                <ClassifyStructure
                                    selectRef={selectRef}
                                    propsForm={form}
                                    prefixTitle="role"
                                    apiRoute='/organization_structure/api/role'
                                    customColumns={[
                                        {
                                            title: '名稱',
                                            dataIndex: 'name',
                                            key: 'name',
                                            render: (text, record, index) => (
                                                record[`role_language_data`]?.[0]?.language_culture_value !== undefined
                                                    ? record[`role_language_data`]?.[0].language_culture_value
                                                    : record.name
                                            )
                                        },
                                        {
                                            title: '層級名稱',
                                            dataIndex: 'depth_name',
                                            key: 'depth_name'
                                        },
                                        // {
                                        //     title: '額外欄位',
                                        //     dataIndex: 'property_json',
                                        //     key: 'property_json',
                                        //     render: (text) => <>
                                        //         <Row>
                                        //             {Object.keys(text).map(item => <Col span={24}>{item}</Col>)}
                                        //         </Row>
                                        //     </>
                                        // },
                                        {
                                            title: '人員數',
                                            dataIndex: 'count_user',
                                            key: 'count_user'
                                        },
                                    ]}
                                    extraActionRender={(record) => <>
                                        <Button type="primary"
                                            size={"small"}
                                            style={{ verticalAlign: 'middle', backgroundColor: "#E6E2C3", color: "black" }}
                                            onClick={(e) => {
                                                getRoleId(record)
                                            }}
                                        >人員</Button>
                                        {record?.classify_structure_type_parent_id === 0 && <>
                                            <PatchDepth
                                                record={record}
                                                prefix='role'
                                                keyPrefix='organization_structure.role.depth'
                                                apiRoute='/organization_structure/api/role_depth'
                                                onReload={() => selectRef.current.reload()}
                                            />
                                        </>}
                                    </>}
                                    customFormItems={() => {
                                        return <>
                                            <Form.Item
                                                name={"role_id"}
                                                hidden
                                            ></Form.Item>
                                            <Form.Item
                                                name={"department_id"}
                                                hidden
                                            ></Form.Item>
                                            <Form.Item
                                                name={"classify_structure_type_id"}
                                                hidden
                                            ></Form.Item>
                                            <Form.Item
                                                name={"role_language_data.0.language_manage_id"}
                                                hidden
                                            ></Form.Item>
                                            <Form.Item
                                                name={"role_language_data.0.language_culture_code"}
                                                hidden
                                            >
                                            </Form.Item>
                                            <Form.Item
                                                name={"role_language_data.0.language_culture_value"}
                                                hidden
                                            >
                                            </Form.Item>
                                            <Form.Item
                                                name={"property_json"}
                                            >
                                                <PropertyJson />
                                            </Form.Item>
                                        </>
                                    }}
                                    classify_structure_id={8}
                                    classify_structure_type_id={0}
                                    initialValues={{
                                        "role_language_data": [
                                            {
                                                "language_manage_id": undefined,
                                                "language_culture_code": "zh-tw",
                                                "language_culture_value": ""
                                            }
                                        ]
                                        // permission_id: null,
                                        // path_check: 0,
                                        // path_check_replace: false,
                                        // show_replace: false,
                                        // show: 0,
                                        // menu_permission_data: [{
                                        //     // menu_id: current_department_id?.current
                                        // }],
                                        // property_json: {
                                        //     blod: false,
                                        //     italic: false,
                                        //     textDecoration: false,
                                        //     background_color1: null,
                                        //     background_color2: null
                                        // }

                                    }}
                                    reorganizeFormData={(value, type) => {
                                        if (type === "submit") {
                                            let newData = [{
                                                "role_id": value?.role_id,
                                                "department_id": undefined,
                                                "department_role_index": 1,
                                                "classify_structure_id": 8,
                                                "classify_structure_type_id": value?.classify_structure_type_id,
                                                "name": value?.name,
                                                "role_language_data": [
                                                    {
                                                        "language_manage_id": value?.role_language_data?.[0]?.language_manage_id,
                                                        "language_culture_code": "zh-tw",
                                                        "language_culture_value": value?.name
                                                    }
                                                ],
                                                "property_json": value?.property_json
                                            }]
                                            let firstData = newData.find((ele) => true)
                                            return {
                                                ...firstData
                                            };
                                        } else if (type === "set") {
                                            let newData = [{
                                                "role_id": value?.role_id,
                                                "department_id": undefined,
                                                "department_id_arr": undefined,
                                                "department_role_index": 1,
                                                "classify_structure_id": 8,
                                                "classify_structure_type_id": value?.classify_structure_type_parent_id,
                                                "name": value?.name,
                                                "role_language_data": [
                                                    {
                                                        "language_manage_id": value?.role_language_data?.[0]?.language_manage_id,
                                                        "language_culture_code": "zh-tw",
                                                        "language_culture_value": value?.name
                                                    }
                                                ],
                                                "property_json": value?.property_json
                                            }]
                                            let firstData = newData.find((ele) => true)
                                            return {
                                                ...firstData
                                            };
                                        }
                                    }}
                                    extraParams={{
                                        // "department_id": current_department_id.current,
                                    }}
                                    forceReload={forceReload}
                                    toolBarRender={(tools) => {
                                        return [
                                            // <DefaultRoleModal />,
                                            ...tools
                                        ]
                                    }}
                                />
                                {/* </>)} */}
                            </Col>
                        </Row>
                        <Col span={24}>
                            {departmentId && roleId && (<>
                                <Modal
                                    contentStyle={{
                                        padding: 16
                                    }}
                                    open={true}
                                    title={`${roleName} - 人員管理`}
                                    okText='儲存'
                                    cancelText='取消'
                                    onOk={() => {
                                        form.submit()
                                    }}
                                    onCancel={() => {
                                        setRoleId(undefined)
                                    }}
                                >
                                    <Form
                                        name="basic"
                                        initialValues={{ remember: true }}
                                        autoComplete="off"
                                        layout="vertical"
                                        form={form}
                                        onFinish={(values) => {
                                            onReset()
                                            postUserRole(departmentId, roleId, targetKeys)
                                        }}
                                    >
                                        {/* <Row justify={"end"}>
                                            <Button type="primary" onClick={() => form.submit()}>
                                                儲存
                                            </Button>
                                        </Row> */}
                                    </Form>
                                    <Transfer
                                        dataSource={userData}
                                        targetKeys={targetKeys}
                                        onChange={onChange}
                                        render={(item) => item.title}
                                        showSearch={true}
                                        pagination
                                        listStyle={{
                                            height: 300,
                                        }}
                                    />
                                </Modal>
                            </>
                            )}
                        </Col>
                    </Col>
                </>}
            </Row>
        </LanguageContext.Provider>
    </>)
}
export default DepartmentRoleManagement;

const DefaultRoleModal = ({
    keyPrefix = "organization_structure.role",
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const [form] = Form.useForm();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [axiosMode, setAxiosMode] = useState("get");
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);

        form.resetFields();
        form.setFieldsValue({
            ...record,
        });
        form.setValue("major", `${record?.major}`)
    };

    const onFormFinish = (values) => {

        let newValues = { ...values };
        if (axiosMode === "post") {
            postDepartmentRoleData([newValues]);
        } else if (axiosMode === "patch") {
            patchDepartmentRoleData([values]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
            } else if (axiosMode === "patch") {
                message.success("修改成功");
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
            }

        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
            }

        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };

    const {
        DepartmentRoleData,
        getDepartmentRoleData,
        deleteDepartmentRoleData,
        postDepartmentRoleData,
        patchDepartmentRoleData
    } = useDepartmentRole({
        onBefore,
        onFinish
    })
    return <>
        <Button onClick={() => { }}>{t('default_role')}</Button>

        <MainModal
            axiosMode={axiosMode}
            propsOpen={modalOpen}
            propsSetOpen={setModalOpen}

            propsForm={form}

            propsLoading={modalLoading}
            propsSetLoading={setModalLoading}

            onFinish={onFormFinish}
            formElement={<DefaultRoleForm />}
        />
    </>
}
const DefaultRoleForm = ({
    keyPrefix = "organization_structure.role",
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const { RoleData, getRoleData } = useRole({})
    return <>

    </>
}
const PropertyJson = ({
    value: value_,
    onChange,
    hasMore = true,
    defaultValue = {},
    ...props
}) => {
    const value = {
        ...defaultValue,
        ...value_,
    }
    const [form] = Form.useForm();
    const setFormValuesOtherThings = (values) => {
        //做一些你可能會用到其他component的資料整理
        const result = values?.property_json?.reduce((acc, curr) => {
            acc[curr.type] = curr.name;
            return acc;
        }, {});
        onChange({
            target: {
                name: props?.name,
                value: {
                    ...result,
                }
            }
        })
        props?.onValueChange({
            target: {
                name: props?.name,
                value: {
                    ...result,
                }
            }
        })
    };
    useEffect(() => {
        form.setFieldsValue({
            property_json: Object.entries(value).map(([type, name]) => (
                {
                    type,
                    name
                }
            ))
        })
    }, [])
    useEffect(() => {
        form.setFieldsValue({
            property_json: Object.entries(value).map(([type, name]) => (
                {
                    type,
                    name
                }
            ))
        })
    }, [value])
    return <>
        <Form
            form={form}
            onValuesChange={(values) => {
                setFormValuesOtherThings(values)
            }}
        >
            <Form.List
                name={"property_json"}
            >
                {(fields, { add, remove }) => <>
                    {hasMore && <Button onClick={() => {
                        add()
                    }}>更多資訊</Button>}
                    {fields.map((field, index) => <>
                        <Row gutter={[16, 16]}>
                            <Col>
                                <Form.Item
                                    label={'欄位名稱'}
                                    name={[field.name, "type"]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item
                                    label={'欄位內容'}
                                    name={[field.name, "name"]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            {hasMore && <Col>
                                <Button
                                    type={'danger'}
                                    onClick={() => {
                                        remove(index)
                                        const values = form.getFieldsValue();
                                        setFormValuesOtherThings(values)
                                    }}
                                >刪除</Button>
                            </Col>}
                        </Row>
                    </>)}
                </>}
            </Form.List>
        </Form>
    </>
}
export { PropertyJson }
const PatchDepth = ({
    record = {},
    prefix = "",
    keyPrefix = "",
    apiRoute = "",
    onReload = () => { }
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const [form] = Form.useForm();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [axiosMode, setAxiosMode] = useState("get");
    const handleEditRow = () => {
        setAxiosMode("post");
        setModalOpen(true);

        form.resetFields();
        form.setFieldsValue({
            [prefix + '_depth_data']: record?.[prefix + '_depth_data'],
        });
    };

    const onFormFinish = (values) => {
        let newValues = { ...values };
        if (axiosMode === "post") {
            // postDepartmentRoleData([newValues]);
            patchData(values);
        } else if (axiosMode === "patch") {
            patchData(values);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
            } else if (axiosMode === "patch") {
                message.success("修改成功");
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
            }
            onReload()
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
            }

        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const { ResponseData, getData, postData, patchData, deleteData } =
        useCRUDController({
            onFinish,
            onBefore,
            apiRoute: apiRoute,
        });
    return <>
        <Button onClick={() => handleEditRow()}>{t('post')}{t('data')}</Button>

        <MainModal
            axiosMode={axiosMode}
            propsOpen={modalOpen}
            propsSetOpen={setModalOpen}
            width={1000}

            propsForm={form}

            propsLoading={modalLoading}
            propsSetLoading={setModalLoading}

            onFinish={onFormFinish}
            keyPrefix={keyPrefix}

            formElement={<DepartmentDepthForm prefix={prefix} record={record} />}
        />
    </>
}
const DepartmentDepthForm = ({
    propsForm = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    prefix = "",
    record = {}
}) => {
    const [form_] = Form.useForm();
    const form = propsForm || form_

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            // total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        // console.log(values);
        onFormFinish(values?.[prefix + '_depth_data'] || [])
        // let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss")
        // let announce_time_end = dayjs(values?.announce_time_end).format("YYYY-MM-DD HH:mm:ss")
        // onFormFinish({
        //     ...values,
        //     news_time,
        //     announce_time_end
        // })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }

    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.List
                        name={prefix + '_depth_data'}>
                        {(fields, { add, remove }) => <>
                            <Row justify={'end'}>
                                <Col>
                                    <Button onClick={() => add({
                                        [prefix + '_id']: record?.[prefix + '_id'],
                                        depth_id: (fields.length + 1)
                                    })}>新增層級</Button>
                                </Col>
                            </Row>
                            {fields.map((field, index) => <>
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Form.Item
                                            hidden={true}
                                            name={[field.name, prefix + "_depth_id"]}
                                        >
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            hidden={true}
                                            name={[field.name, "depth_id"]}
                                        >
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            hidden={true}
                                            name={[field.name, prefix + "_id"]}
                                        >
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Row justify={'end'} gutter={[8, 8]}>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={`第${(index + 1)}層級標題`}
                                                    name={[field.name, "name"]}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "請輸入"
                                                        }
                                                    ]}
                                                >
                                                    <Input>
                                                    </Input>
                                                </Form.Item>
                                            </Col>
                                            <Col>
                                                <Button
                                                    type={'danger'}
                                                    onClick={() => remove(index)}
                                                    style={fields.length - 1 === index ? {} : {
                                                        display: 'none'
                                                    }}
                                                >刪除</Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            name={[field.name, "property_json"]}
                                        >
                                            <PropertyJson />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>)}
                        </>}
                    </Form.List>
                </Form>
            </Col>
        </Row>
    )
}
